export const fontOptions = ['system', 'inter', 'manrope', 'lora', 'jetbrains-mono', 'roobert'] as const
export type FontOption = (typeof fontOptions)[number]

export const fontOptionMeta: Record<FontOption, { label: string; family: string }> = {
  system: { label: 'System', family: 'system-ui, sans-serif' },
  inter: { label: 'Inter', family: "'Inter', sans-serif" },
  manrope: { label: 'Manrope', family: "'Manrope', sans-serif" },
  lora: { label: 'Lora', family: "'Lora', Georgia, serif" },
  'jetbrains-mono': { label: 'JetBrains Mono', family: "'JetBrains Mono', monospace" },
  roobert: { label: 'Roobert', family: "'Roobert', sans-serif" },
}
